import React from 'react';
import ReactDOM from 'react-dom';
import { Route, BrowserRouter, Switch } from 'react-router-dom'
import './index.css';
import Home from './Home';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
 
function App(){
  return (
    <React.StrictMode>     
      <BrowserRouter>
          <Switch> 
              {/* <Route path="/plot/:id/" component={Plot} /> */}
              <Route path="/" component={Home} />  
              {/* <Route component={NotFound} />  */}
          </Switch>
          </BrowserRouter>
    </React.StrictMode>
  )
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('vw-app-root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
